"use client";

import { type ImageProps } from "next/image";
import Image from "@/components/ui/image";
import { useState } from "react";

/** An app icon that draws nothing when the image fails, so the tile behind it shows instead of a broken-image glyph. */
export function AppIconImage(props: ImageProps) {
  const [errored, setErrored] = useState(false);
  if (errored) return null;
  return <Image {...props} alt={props.alt} onError={() => setErrored(true)} />;
}
